import {
    Datagrid,
    DeleteButton,
    EditButton,
    Filter,
    Link,
    List,
    ReferenceManyCount,
    TextField,
    TextInput,
    useRecordContext,
} from 'react-admin';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import useIsPermission from '../../hooks/useIsPermission';
import PermissionBasedActions from '../../common/PermissionBasedActionsButton';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';

const PdfsLinkComponent = () => {
    const record = useRecordContext();
    return (
        <Link to={`/pdfs?filter=${encodeURIComponent(JSON.stringify({ categoryId: record.id }))}`}>
            Pdfs
        </Link>
    );
};

const ListFilter = (props: any) => (
    <Filter {...props}>
        <TextInput label="Search" source="name" alwaysOn />
    </Filter>
);

const PdfCategoriesList = () => {
    const { isUpdatable, isDeletable, isWritable } = useIsPermission('PDF_CATEGORIES');

    return (
        <div>
            <List
                filters={<ListFilter />}
                actions={<PermissionBasedActions isWritable={isWritable} />}
                queryOptions={{
                    refetchOnWindowFocus: false,
                    refetchOnReconnect: false,
                }}
            >
                <Datagrid bulkActionButtons={false}>
                    <TextField source="name" />
                    <FormattedDateTimeField source="created_at" />
                    <PdfsLinkComponent />
                    {isUpdatable && <EditButton />}
                    {isDeletable && <ConfirmDeleteButton />}
                </Datagrid>
            </List>
        </div>
    );
};

export default PdfCategoriesList;
